import { render } from "./Item.vue?vue&type=template&id=8faeb3aa&scoped=true"
import script from "./Item.vue?vue&type=script&lang=ts"
export * from "./Item.vue?vue&type=script&lang=ts"

import "./Item.vue?vue&type=style&index=0&id=8faeb3aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8faeb3aa"

export default script